/* eslint-disable camelcase */
import api from '../../api'

export default {
  namespaced: true,
  state: {
    pages: []
  },
  getters: {
    getPages: state => state.pages
  },
  mutations: {
    SET_PAGES: (state, data) => {
      state.pages = data
    }
  },
  actions: {
    async getPages (context) {
      const res = await api.getPages()
      if (res && res.data) {
        context.commit('SET_PAGES', res.data)
        return res
      }
      throw new Error(res)
    }
  }
}
